document.addEventListener('DOMContentLoaded', function () {
  // dacă tema ta pune clasa template-product pe body, păstrăm filtrul;
  // dacă nu, poți șterge complet if-ul de mai jos
  if (document.body && document.body.classList.contains('template-product') === false) {
    // return; // decomentează dacă vrei să ruleze doar pe pagini de produs
  }

  // căutăm iframe-uri din descrieri (în majoritatea temelor HTML-ul de descriere are clasa .rte)
  var iframes = document.querySelectorAll('.rte iframe, main iframe');

  iframes.forEach(function (iframe) {
    if (!iframe.src) return;

    var src = iframe.src;
    var isVideo = /youtube\.com|youtu\.be|facebook\.com\/plugins\/video|vimeo\.com/i.test(src);
    if (!isVideo) return;

    var parent = iframe.parentElement;
    if (parent && parent.classList && parent.classList.contains('embed-youtube')) {
      return;
    }

    var w = 0;
    var h = 0;

    // 1) Încercăm width/height din URL (Facebook, unele embed-uri YouTube/Vimeo)
    var qIndex = src.indexOf('?');
    if (qIndex !== -1) {
      try {
        var params = new URLSearchParams(src.substring(qIndex + 1));
        var pw = parseInt(params.get('width') || '', 10);
        var ph = parseInt(params.get('height') || '', 10);
        if (pw > 0 && ph > 0) {
          w = pw;
          h = ph;
        }
      } catch (e) {}
    }

    // 2) Dacă nu avem încă valori, luăm din atributele HTML, dar ignorăm valorile cu %
    if (w === 0 || h === 0) {
      var aw = iframe.getAttribute('width');
      var ah = iframe.getAttribute('height');

      if (aw && aw.indexOf('%') === -1) {
        var n = parseInt(aw, 10);
        if (n > 0) w = n;
      }

      if (ah && ah.indexOf('%') === -1) {
        var m = parseInt(ah, 10);
        if (m > 0) h = m;
      }
    }

    var ratio = 56.25; // fallback 16:9

    if (w > 0 && h > 0) {
      ratio = (h / w) * 100;

      // limite de siguranță, să nu avem monștri de 400% înălțime
      if (ratio < 40) ratio = 40;
      if (ratio > 200) ratio = 200;
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'embed-youtube';
    wrapper.style.paddingBottom = ratio + '%';

    parent.insertBefore(wrapper, iframe);
    wrapper.appendChild(iframe);

    iframe.removeAttribute('width');
    iframe.removeAttribute('height');
  });
});

// Tawk.to - mută widgetul mai sus (yOffset în px)
window.Tawk_API = window.Tawk_API || {};
window.Tawk_API.customStyle = {
  visibility: {
    desktop: { position: "br", xOffset: 16, yOffset: 50 },
    mobile:  { position: "br", xOffset: 16, yOffset: 50 }
  }
};